module.exports = __webpack_public_path__ + "static/media/1-15.3e2c11e6.mp3";